import {
    CalendarBookingViewModel,
} from '@app/features/bookings/components/booking-graph/view-models/calendar-booking-view-model'
import { Component, Input } from '@angular/core'
import { DateTime } from 'luxon'
import { environment } from '../../../../../../../environments/environment'
import { BookingSource } from '@app/domain/BookingSource'

@Component({
    selector: 'app-booking-tooltip',
    templateUrl: './booking-tooltip.component.html',
    styleUrls: ['./booking-tooltip.component.sass'],
})
export class BookingTooltipComponent {

    @Input() viewModel!: CalendarBookingViewModel
    protected readonly environment = environment
    protected readonly DateTime = DateTime
    protected readonly BookingSource = BookingSource
}
